export interface CountryRecommendedCategory {
    id: string;
    country_recommended_id?: string;
    recommed_id?: string;
    recommended_id?: string;
    display_title?: string;
    title?: string;
    description?: string;
    image?: string;
    icon?: string;
    order_by?: number;
    min_application?: number;
    is_active?: boolean;
    is_recommended?: boolean;
    is_hidden?: boolean;
    slug?: string;
    tags?: string;
    category?: {
        is_hidden?: boolean;
        slug?: string;
        tags?: string;
    };
    translations?: Array<{ title?: string; display_title?: string; description?: string; language_code?: string; slug?: string }>;
}

export interface CategoryCampaign {
    id: string;
    campaign_category_id?: string;
    campaign_id?: string;
    campaign_name?: string;
    brand_name?: string;
    campaign_image?: string | null;
    attachment?: string[];
    platforms?: string[];
    campaignCategory?: Array<{
        id: string;
        order_by?: number;
        countryOrders?: Array<{
            id: string;
            order_by?: number;
            is_hidden?: boolean
        }>;
    }>;
    users?: {
        image?: string;
        display_name?: string;
        company_name?: string;
        first_name?: string;
        last_name?: string;
    };
    image?: string;
    status?: string;
    order_by?: number;
    created_at?: string;
    posting_start_date?: string;
    applications_count?: number;
    social_media?: Array<{ social_type?: string; count?: number }>;
}

export const getCampaignCategoryId = (campaign: CategoryCampaign) =>
    campaign.campaignCategory?.[0]?.id ?? '';

export const isCampaignHidden = (campaign: CategoryCampaign) =>
    !!campaign.campaignCategory?.[0]?.countryOrders?.[0]?.is_hidden

export const getCountryOrderBy = (campaign: CategoryCampaign) =>
    campaign.campaignCategory?.[0]?.countryOrders?.[0]?.order_by;

export const getCountryRecommendedId = (category: CountryRecommendedCategory) => category.recommended_id ?? '';

export const getCategoryTitle = (category: CountryRecommendedCategory) =>
    category.translations?.[0]?.display_title ??
    '';

export const getCategoryDescription = (category: CountryRecommendedCategory) =>
    category.translations?.[0]?.description ??
    '';

export const getCategorySlug = (category: CountryRecommendedCategory) => {
    return (category.translations?.[0]?.slug ?? '').trim().toLowerCase();
}

export const getCategoryTag = getCategorySlug;

export const isCategoryLocked = (category: CountryRecommendedCategory) =>
    !!(category.is_hidden ?? category.category?.is_hidden);

export const isHotCategory = (category: CountryRecommendedCategory) =>
    getCategorySlug(category) === 'hot';

export const isAllCategory = (category: CountryRecommendedCategory) =>
    getCategorySlug(category) === 'all';

export const isInternationalCategory = (category: CountryRecommendedCategory) =>
    getCategorySlug(category) === 'international';

export const buildJobListingCategoryId = (
    selectedCategoryId: string | null,
    internationalCategoryId: string | null
): string | undefined => {
    if (!selectedCategoryId) return undefined;
    if (!internationalCategoryId || selectedCategoryId === internationalCategoryId) {
        return selectedCategoryId;
    }
    return `${selectedCategoryId},${internationalCategoryId}`;
};
